import { type AutocompleteRenderInputParams, TextField } from "@mui/material";

import { PathParser } from "@/shared/domain/topics";

import { MessagePathHelp } from "./MessagePathHelp";
import styles from "./PathSelector.module.css";

interface PathSelectorInputProps {
  hasExactMatch: boolean;
  hasError: boolean;
  inputValue: string;
  inputParams: AutocompleteRenderInputParams;
  label: string;
  selectorIsOpen: boolean;
}

function getInputColorHint({
  hasError,
  hasExactMatch,
}: {
  hasError: boolean;
  hasExactMatch: boolean;
}) {
  if (hasError) {
    return "error";
  }

  if (hasExactMatch) {
    return "success";
  }

  return undefined;
}

export function PathSelectorInput({
  hasExactMatch,
  hasError,
  inputValue,
  inputParams,
  label,
  selectorIsOpen,
}: PathSelectorInputProps) {
  const placeholderExample = [
    "esc_status",
    PathParser.TOPIC_SEPARATOR,
    "esc[2:7]",
    PathParser.MESSAGE_PATH_SEPARATOR,
    "esc_power",
  ].join("");

  return (
    <TextField
      {...inputParams}
      color={getInputColorHint({ hasError, hasExactMatch })}
      error={hasError}
      fullWidth
      InputProps={{
        ...inputParams.InputProps,
        className: styles.input,
        endAdornment: (
          <>
            {inputParams.InputProps.endAdornment}
            <MessagePathHelp show={inputValue.length > 0 && selectorIsOpen} />
          </>
        ),
      }}
      InputLabelProps={{
        ...inputParams.InputLabelProps,
        className: styles.input,
      }}
      label={label}
      placeholder={`e.g., ${placeholderExample}`}
    />
  );
}
